
import Vue from 'vue'

/**
 * Mark sinister to revision
 * @param  payload File and id
 */

const markSinisterToRevision = ({ workPlanExpectId }) =>
  Vue.$http.put(`workplan/real/mark_to_review/${workPlanExpectId}/`, {
    is_mark_to_review: true
  })
    .then()
    .catch((err) => {
      throw err
    })

export default markSinisterToRevision



// WEBPACK FOOTER //
// ./src/services/workPlan/markSinisterToRevision.js